import React, { FC } from 'react';

import { pharmacistBooking, PharmacistLegendVariant } from '@pharmaplan/common';
import { idStore } from '@pharmaplan/common/helpers/ServiceHandler';

import AdminLongTermUserRates from '../../common/AdminHourlyRateFooter/AdminLongTermUserRates';
import AdminHourlyRateFooter from '../../common/AdminHourlyRateFooter';
import ViewAllLongTermContracts from '../../ViewAllLongTermContracts';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { setDialog } from '../../../reducers/dialogReducer';
import { Constants } from '../../../helpers/Constants';
import CustomButton from '../../common/CustomButton';
import strings from '../../../localization';

import styles from './styles';
import useSelfService from '../../../hooks/useSelfService';

const { text } = Constants.variant;

interface IPharmacyBookingDetailsFooter {
  successAction: string;
}

const PharmacyBookingDetailsFooter: FC<IPharmacyBookingDetailsFooter> = ({
  successAction,
}) => {
  const dispatch = useAppDispatch();
  const { isSelfService } = useSelfService();

  const details = useAppSelector(pharmacistBooking);

  const {
    pharmacyHourlyRate,
    pharmacistHourlyRate,
    longTermShiftContract,
    pharmacyWeekDayHourlyRate,
    professionalHourlyRate,
    pharmacyWeekendHourlyRate,
  } = details ?? {};

  const {
    longTermShiftContractId,
    weekDayPaidHourlyRate,
    weekendPaidHourlyRate,
  } = longTermShiftContract ?? {};

  const userHourlyRate = isSelfService ? professionalHourlyRate : pharmacistHourlyRate;

  const goToBookings = () => {
    dispatch(
      setDialog({
        heading: {
          title: strings.bookingDetails,
        },
        Component: (
          <ViewAllLongTermContracts
            type={PharmacistLegendVariant.booked}
            longTermContractId={longTermShiftContractId ?? ''}
            professionalId={
              details?.[idStore.id as keyof typeof details] as string
            }
          />
        ),
        maxWidth: 'lg',
        showCloseButton: true,
      }),
    );
  };

  const { customPharmacistChip, customPharmacyChip } = AdminLongTermUserRates({
    pharmacyWeekDayHourlyRate,
    pharmacyWeekendHourlyRate,
    weekDayHourlyRate: weekDayPaidHourlyRate,
    weekendHourlyRate: weekendPaidHourlyRate,
    successAction,
    contractStartDate: longTermShiftContractId,
  });

  return (
    <>
      <AdminHourlyRateFooter
        pharmacyHourlyRate={pharmacyHourlyRate ?? 0}
        pharmacistHourlyRate={userHourlyRate}
        successAction={successAction}
        customPharmacistChip={customPharmacistChip}
        customPharmacyChip={customPharmacyChip}
      />

      {!!longTermShiftContractId && (
      <CustomButton
        label={strings.viewAllBookings}
        onClick={goToBookings}
        customClass={styles.buttonContainer}
        customButtonStyle={styles.button}
        variant={text}
      />
      )}
    </>
  );
};

export default PharmacyBookingDetailsFooter;
